import { render } from "./SingleGalleryComponent.vue?vue&type=template&id=187b4f0c"
import script from "./SingleGalleryComponent.vue?vue&type=script&lang=js"
export * from "./SingleGalleryComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/twilkinson/Documents/DevProjects/AF3/af3-shortcodes-plugin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__